// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"46110":"0d923190340407ee","50213":"382b0f3ac33be655"}[chunkId] + ".css";
};